import * as Yup from 'yup'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { cnpjValido, somenteDigitos } from '../../../core/formularioFornecedor'

export const TIPOS_LOGO_ACEITOS = ['image/png', 'image/jpeg', 'image/webp']
export const TAMANHO_MAXIMO_LOGO = 2 * 1024 * 1024

/** Mesmos limites do `FornecedorDtoCreate`. Logo só PNG, JPEG ou WebP até 2 MB (sem SVG). */
export const fornecedorSchema = (t: TFunction) =>
  Yup.object().shape({
    nome: Yup.string()
      .trim()
      .required(t('pagina.fornecedores.validacao.nome_obrigatorio'))
      .max(150, t('pagina.fornecedores.validacao.max', { max: 150 })),
    nomeFantasia: Yup.string().max(150, t('pagina.fornecedores.validacao.max', { max: 150 })),
    cnpj: Yup.string().test(
      'cnpj',
      t('pagina.fornecedores.validacao.cnpj_invalido'),
      (valor) => !somenteDigitos(valor) || cnpjValido(valor)
    ),
    inscricaoEstadual: Yup.string().max(20, t('pagina.fornecedores.validacao.max', { max: 20 })),
    email: Yup.string()
      .email(t('pagina.fornecedores.validacao.email_invalido'))
      .max(150, t('pagina.fornecedores.validacao.max', { max: 150 })),
    telefone: Yup.string().max(20, t('pagina.fornecedores.validacao.max', { max: 20 })),
    site: Yup.string().max(200, t('pagina.fornecedores.validacao.max', { max: 200 })),
    contatoNome: Yup.string().max(100, t('pagina.fornecedores.validacao.max', { max: 100 })),
    contatoTelefone: Yup.string().max(20, t('pagina.fornecedores.validacao.max', { max: 20 })),
    contatoEmail: Yup.string()
      .email(t('pagina.fornecedores.validacao.email_invalido'))
      .max(100, t('pagina.fornecedores.validacao.max', { max: 100 })),
    tipos: Yup.array().min(1, t('pagina.fornecedores.validacao.tipos_obrigatorio')),
    logo: Yup.mixed()
      .nullable()
      .test(
        'tipoLogo',
        t('pagina.fornecedores.validacao.logo_tipo'),
        (arquivo) => !arquivo || TIPOS_LOGO_ACEITOS.includes((arquivo as File).type)
      )
      .test(
        'tamanhoLogo',
        t('pagina.fornecedores.validacao.logo_tamanho'),
        (arquivo) => !arquivo || (arquivo as File).size <= TAMANHO_MAXIMO_LOGO
      ),
  })
